module.exports = {
  latlng: [51.51475, 7.46489],
  zoom: 14,
  title: 'Westfalen als Häusermeer',
  introtext:'Wie gut kennen Sie sich wirklich in der Region aus? Erkennen Sie Orte nur anhand der Gebäudeumrisse? Machen Sie das Häuserquiz und ordnen Sie den neun Häuserkarten die richtigen Orte zu. Zu jedem Ausschnitt gibt es einen kleinen Tipp.',
  resultSentences: [
    'Sie waren höchstens mal auf der Durchfahrt hier.',
    'Tourist? Beruflich unterwegs? Sie leben bestimmt nicht hier.',
    'Immerhin kennen Sie ein paar Ecken in der Region.',
    'Nicht schlecht. Sie kennen sich halbwegs aus hier.',
    'Wow! Alles richtig. Sie wirklich ein Experte für die Region.'
  ],
  questions: [
    {
      id: 'WR 1',
      lat: 51.3560776,
      lng: 7.4730112,
      zoom: 17,
      answers: [
        'Deutsches Fußball Museum',
        'Osthaus-Museum',
        'Ruhr Museum'
      ],
      correctAnswer: 'Osthaus-Museum',
      description: 'Einst befand sich dort das Folkwang-Museum.'
    },
    {
      id: 'WR 2',
      lat: 51.4902531,
      lng: 7.5134102,
      zoom: 14,
      answers: [
        'Phoenixsee',
        'Kemnader See',
        'Hartkortsee'
      ],
      correctAnswer: 'Phoenixsee',
      description: 'Bis 2001 war dies das Areal eines Stahlwerks.'
    },
    {
      id: 'WR 3',
      lat: 50.8745,
      lng: 8.01686,
      zoom: 15,
      answers: [
        'Dortmund',
        'Bochum',
        'Siegen'
      ],
      correctAnswer: 'Siegen',
      description: 'Seit 2007 hat die Stadt mit der Eröffnung des Apollo ihr erstes eigenes Theater.'
    },
    {
      id: 'WR 4',
      lat: 51.4920833,
      lng: 7.4534373,
      zoom: 14,
      answers: [
        'Stadion Nattenberg',
        'Signal-Iduna-Park Dortmund',
        'Vonovia Ruhrstadion'
      ],
      correctAnswer: 'Signal-Iduna-Park Dortmund',
      description: 'Mehr als 80.000 Zuschauer haben hier Platz.'
    },
    {
      id: 'WR 5',
      lat: 51.358813,
      lng: 7.474085,
      zoom: 15,
      answers: [
        'Hagen',
        'Meschede',
        'Oberhausen'
      ],
      correctAnswer: 'Hagen',
      description: 'Die Stadt wird auch Tor zum Sauerland genannt.'
    },
    {
      id: 'WR 6',
      lat: 51.4439146,
      lng: 7.2615507,
      zoom: 14,
      answers: [
        'Universität Duisburg-Essen',
        'Ruhr-Uni Bochum',
        'Technische Universität Dortmund'
      ],
      correctAnswer: 'Ruhr-Uni Bochum',
      description: 'Die erste Universitätsneugründung in der Bundesrepublik.'
    },
    {
      id: 'WR 7',
      lat: 51.348193,
      lng: 8.280633,
      zoom: 15,
      answers: [
        'Meschede',
        'Herdecke',
        'Iserlohn'
      ],
      correctAnswer: 'Meschede',
      description: 'In einem Ortsteil der Stadt ist der Sitz der Veltins-Brauerei.'
    },
    {
      id: 'WR 8',
      lat: 51.38729,
      lng: 7.38732,
      zoom: 14,
      answers: [
        'Herdecke',
        'Altena',
        'Wetter'
      ],
      correctAnswer: 'Wetter',
      description: 'Der Name Harkort ist in dieser Stadt hier Programm'
    },
    {
      id: 'WR 9',
      lat: 51.512677,
      lng: 7.459395,
      zoom: 15,
      answers: [
        'Thier-Galerie Dortmund',
        'Centro Oberhausen',
        'City Galerie Siegen'
      ],
      correctAnswer: 'Thier-Galerie Dortmund',
      description: 'Dieses Einkaufszentrum in der Innenstadt wurde 2011 eröffnet.'
    }
  ]
}